
import { mapGetters } from "vuex";

import { setLanguage } from "@/lib/i18n";
import { apiCall } from "@/lib/api";
import MultiSelect from "@/components/MultiSelect.vue";
import { Component, MixedVue, mixins } from "@/vue";
import { propsInstance } from "@/lib/util";
import { Watch } from "vue-property-decorator";
import { User } from "@/lib/types/User";

const Props = propsInstance<{
  short?: boolean;
  responsive?: boolean;
  inverted?: boolean;
  dropDownDirection?: "left" | "right";
  renderAs?: "buttonGroup" | "dropdown";
}>({
  short: {
    type: Boolean,
    default: false,
    required: false,
  },
  responsive: {
    type: Boolean,
    default: false,
    required: false,
  },
  inverted: {
    type: Boolean,
    default: false,
    required: false,
  },
  dropDownDirection: {
    type: String as any,
    default: "left",
    required: false,
  },
  renderAs: {
    type: String as any,
    default: "buttonGroup",
    required: false,
  },
});

/**
 * Language select component:
 *  - display the list of available languages
 *  - indicate which language is currently active
 *  - change the currently selected language
 */
@Component({
  name: "LanguageSelect",
  components: { MultiSelect },
})
export default class LanguageSelect extends mixins(MixedVue, Props) {
  selectedLanguage = this.$language.current;

  get currentLanguage() {
    return this.$language.current.toUpperCase();
  }

  get availableLanguages() {
    return Object.entries(this.$language.available).map(([code, label]) => {
      return { langCode: code.toUpperCase(), label };
    });
  }

  @Watch("$language.current")
  onLanguageChanged() {
    this.selectedLanguage = this.$language.current;
  }

  languageChange(code: typeof this.availableLanguages[0] | string) {
    if (typeof code === "object") {
      code = code.langCode.toLowerCase();
    }
    this.selectedLanguage = code;

    setLanguage(code, this);

    // If the user is logged in store their preference in the backend
    if (this.$store.getters.user.email) {
      apiCall<User>("PATCH", "/auth/user/", {}, { preferred_language: code.toUpperCase() }).then((response) => {
        this.$store.commit("setCurrentUser", response);
      });
    }
  }
}
